import React from "react";
import ContentLoader from "react-content-loader";

const ListLoader = (props: IListLoader) => {
  return (
    <ContentLoader height={120} width={400} speed={props.speed ? props.speed : 4}>
      <rect x="0" y="0" rx="0" ry="0" width={props.canvasWidth ? props.canvasWidth : "400"} height="30" />
      <rect x="0" y="40" rx="0" ry="0" width={props.canvasWidth ? props.canvasWidth : "400"} height="30" />
      <rect x="0" y="80" rx="0" ry="0" width={props.canvasWidth ? props.canvasWidth : "400"} height="30" />
    </ContentLoader>
  );
};

export default ListLoader;

interface IListLoader {
  speed?: number;
  canvasWidth?: string;
}
